import { Injectable } from '@angular/core';

import { Actions, State } from '@ngxs/store';

import { ReferralReward } from '@recruitee/http/types';

import { HttpApiService } from '../../../core/http-api.service';
import { EntityStateHelpers, EntityUpdateStrategy, IEntityState } from '../../../core/state';
import { EntityState } from '../../../core/state/entity-state';

type RepositoryType = IEntityState<ReferralReward>;

@State<RepositoryType>({
  name: 'referral_rewards',
  defaults: EntityStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsRewardRepo extends EntityState<ReferralReward>() {
  constructor(private httpApi: HttpApiService, protected actions$: Actions) {
    super(actions$, EntityUpdateStrategy.update);
  }
}
